import actionTypes from '../../action-types'

export default (payload, meta) => ({
  type: actionTypes.ADMINISTRATORS.SET_ALL,
  payload,
  meta,
})
